import axios from "axios";
import store from "./store";
import router from "@/router";

const instance = axios.create({
  baseURL: process.env.VUE_APP_CATERPOINT + "/restapi/",
});

instance.interceptors.response.use(
  function(response) {
    // Do something with response data
    return response;
  },
  function(error) {
    // Do something with response error
    if (error.response) {
      if (error.response.status == 401) {
        store.dispatch("setSnackbar", {
          color: "error",
          text: "Unauthorized - You can only sign in on one device at a time",
        });

        store.dispatch("userSignoutAction");
        router.push({ name: "Welcome" });
      }

      return Promise.reject(error);
    } else {
      //Couldn't connect to server
      return false;
    }
  }
);

export default instance;
